import React, { useRef } from "react";
import html2pdf from "html2pdf.js";
import "./StudentPerformanceReportPdfStyles.css";
import logo from "../../assets/img/logo-full.png";
import studentImage from "../../assets/img/generic/student-girl.jpg";

const StudentPerformanceReportPdfGenerator = ({ reportData }) => {
  const pdfRef = useRef();

  const generatePdf = () => {
    const element = pdfRef.current;

    // Configure PDF options
    const options = {
      margin: 0.2,
      filename: "student-performance-report.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
    };

    // Generate PDF
    html2pdf()
      .set(options)
      .from(element)
      .outputPdf("blob") // Output the PDF as a blob
      .then((pdfBlob) => {
        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfUrl, "_blank");
      });
  };

  return (
    <>
      <div className="pdf-content">
        <div className="d-flex">
          <button
            onClick={generatePdf}
            className="btn btn-danger btn-sm mb-3 ms-auto"
          >
            Open PDF
          </button>
        </div>
        <div ref={pdfRef}>
          <div className="row mb-3">
            <div className="col-2">
              {/* <img
                src={logo}
                alt="logo"
                style={{ height: "25px", width: "auto" }}
              /> */}
              <p>{reportData.organizationName}</p>
            </div>
            <div className="col-8 text-center">
              <h4 className="mb-2">Student Performance Report</h4>
              <h5>
                {reportData.studentName} - {reportData.classSection}
              </h5>
              <h6>{reportData.termName}</h6>
            </div>
            <div className="col-2 text-end d-none">
              <div className="student-picture">
                <img src={studentImage} alt="student-picture" />
              </div>
            </div>
          </div>

          {/* <div className=" fs-9 mb-3">
            <div>
              <strong>Date of Birth:</strong> November 9, 2016
            </div>
            <div>
              <strong>Attendance:</strong> 86 (out of 90 days)
            </div>
          </div> */}

          {/* <h5 className="mb-1 text-center">
            Understanding your child’s report
          </h5>
          <div className="border mb-3">
            <ul className="list-unstyled fs-9 p-3 mb-0">
              <h6>Colour coded performance indicators (PI):</h6>
              <li className="list-style-item">
                <span style={{ display: "inline-block", width: "60px" }}>
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "green",
                      display: "inline-block",
                      marginRight: "5px",
                      verticalAlign: "middle",
                    }}
                  ></span>
                  <span
                    style={{
                      color: "green",
                      fontWeight: "bold",
                      verticalAlign: "middle",
                    }}
                  >
                    (EXC)
                  </span>
                </span>
                Exceeding Development: Performs above the expected level,
                showing advanced skills.
              </li>
              <li className="list-style-item">
                <span style={{ display: "inline-block", width: "60px" }}>
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "blue",
                      display: "inline-block",
                      marginRight: "5px",
                      verticalAlign: "middle",
                    }}
                  ></span>
                  <span
                    style={{
                      color: "blue",
                      fontWeight: "bold",
                      verticalAlign: "middle",
                    }}
                  >
                    (EXP)
                  </span>
                </span>
                Expected Development: Consistently meets the learning objective
                independently.
              </li>
              <li className="list-style-item">
                <span style={{ display: "inline-block", width: "60px" }}>
                  <span
                    style={{
                      width: "10px",
                      height: "10px",
                      backgroundColor: "purple",
                      display: "inline-block",
                      marginRight: "5px",
                      verticalAlign: "middle",
                    }}
                  ></span>
                  <span
                    style={{
                      color: "purple",
                      fontWeight: "bold",
                      verticalAlign: "middle",
                    }}
                  >
                    (EME)
                  </span>
                </span>
                Emerging Development: Performs below the expected level,
                requiring support and guidance.
              </li>
            </ul>
          </div> */}

          <table className="table custom-table table-bordered">
            <thead>
              <tr>
                <th>Activity</th>
                <th>Subject</th>
                <th>Rating</th>
              </tr>
            </thead>
            <tbody>
              {reportData.resultDetail.map((item, index) => (
                <tr key={index}>
                  <td>{item.performanceEvaluation}</td>
                  <td>{item.subjectName}</td>
                  <td>{item.acheivementRatingCode}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div>
            <h6>Class Teacher's Comments:</h6>
            <p className="fs-9 text-secondary">
              {reportData.classTeacherComments}
            </p>
          </div>
          <div>
            <h6>School Head's Comments:</h6>
            <p className="fs-9 text-secondary">
              {reportData.schoolHeadComments}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default StudentPerformanceReportPdfGenerator;
